/**
 Author - Saahil Madaan
 Git - https://bitbucket.org/techSavvySaahil/
 **/

import Confirmation from "./Confirmation";

export default Confirmation;
